(() => {
  const footerDesktop = document.querySelector(".footer-menu__holder--desktop");

  const footerMobile = document.querySelector(".footer-menu__holder--mobile");

  const findHeightOfElement = (column) => {
    const height = Array.from(column.children).reduce(
      (acc, curr) => acc + curr.children.length,
      0
    );
    return height;
  };

  const findSmallestColumn = (columns) => {
    let minColumn = 0;
    columns.forEach((column, index) => {
      if (
        findHeightOfElement(column) < findHeightOfElement(columns[minColumn])
      ) {
        minColumn = index;
      }
    });
    return minColumn;
  };

  const distribute = (parent) => {
    const columns = Array.from(parent.querySelectorAll(".footer-menu__column"));

    const menus = Array.from(parent.querySelector(".js-footer-menus").children);

    for (let index = 0; index < menus.length; index += 1) {
      const smallestColumn = findSmallestColumn(columns);
      columns[smallestColumn].append(menus[index].cloneNode(true));
    }
  };

  distribute(footerDesktop);

  distribute(footerMobile);
})();
